module.exports = __webpack_public_path__ + "img/cob.c6669d6d.svg";